export default __webpack_public_path__ + "static/media/laptop-icon.172a45e0.svg";